// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();

import './js/nav';

if($('.music-videos__work').length) {

	$( ".music-videos__work-video" ).click(function() {
		if($(this).find('img').hasClass('video-visible')) {
			$(this).find('img').removeClass('video-visible');
			$(this).find('video').trigger('play');
			$(this).find('.bi-play-fill').hide();
			$(this).find('.bi-pause-fill').show();
		}

		else {
			$(this).find('img').addClass('video-visible');
			$(this).find('video').trigger('pause');
			$(this).find('.bi-play-fill').show();
			$(this).find('.bi-pause-fill').hide();
		}

	});

}
